/* ── ML Custom Nav Drawer — dialog-based ── */
(function () {
  function init() {
    if (document.getElementById('ml-nav-dialog')) return;

    var LINKS = [
      { label: 'New In',    url: '/collections/ss26-2' },
      { label: 'Shop All',  url: '/collections/all-products-smart' },
      { label: 'Hoodies',   url: '/collections/homeware' },
      { label: 'Tartans',   url: '/collections/tartan-hidden-pocket-hoodies' },
      { label: 'Denims',    url: '/collections/pant' },
      { label: 'Shirts',    url: '/collections/shirts' },
      { label: 'Fur',       url: '/collections/fur' },
      { label: 'Archive',   url: '/pages/archive' },
      { label: 'Contact',   url: '/pages/contact-us' },
    ];

    var dialog = document.createElement('dialog');
    dialog.id = 'ml-nav-dialog';

    var closeBtn = document.createElement('button');
    closeBtn.id = 'ml-nav-close';
    closeBtn.innerHTML = '&times;';
    dialog.appendChild(closeBtn);

    var nav = document.createElement('nav');
    nav.id = 'ml-nav-links';
    LINKS.forEach(function(item) {
      var a = document.createElement('a');
      a.href = item.url;
      a.textContent = item.label;
      nav.appendChild(a);
    });
    dialog.appendChild(nav);
    document.body.appendChild(dialog);

    var isOpen = false;

    function cleanupTheme() {
      var details = document.getElementById('Details-menu-drawer-container');
      if (details) {
        details.classList.remove('menu-open');
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
      var headerDrawer = document.querySelector('header-drawer');
      if (headerDrawer && typeof headerDrawer.close === 'function') {
        headerDrawer.close();
      }
    }

    function openNav() {
      if (isOpen) return;
      isOpen = true;
      cleanupTheme();
      dialog.showModal();
      requestAnimationFrame(function() {
        dialog.classList.add('ml-active');
      });
    }

    function closeNav() {
      if (!isOpen) return;
      isOpen = false;
      dialog.classList.remove('ml-active');
      setTimeout(function() {
        dialog.close();
        var hamburger = document.querySelector('summary.header__icon--menu, summary.header__icon--summary');
        if (hamburger) hamburger.blur();
      }, 350);
    }

    closeBtn.addEventListener('click', closeNav);

    dialog.addEventListener('click', function(e) {
      var rect = dialog.getBoundingClientRect();
      var inDialog = (
        e.clientX >= rect.left && e.clientX <= rect.right &&
        e.clientY >= rect.top  && e.clientY <= rect.bottom
      );
      if (!inDialog) closeNav();
    });

    dialog.addEventListener('cancel', function(e) {
      e.preventDefault();
      closeNav();
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('summary.header__icon--menu, summary.header__icon--summary');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isOpen) closeNav(); else openNav();
    }, true);

    dialog.addEventListener('wheel', function(e) { e.stopPropagation(); }, { passive: true });
    dialog.addEventListener('touchmove', function(e) { e.stopPropagation(); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Cart scroll-jump fix ── */
(function() {
  if (window._mlScrollPatched) return;
  window._mlScrollPatched = true;

  var orig = window.scrollTo.bind(window);
  var pendingScrollY = null;

  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.cart-drawer__close-button');
    if (!closeBtn) return;
    var top = document.body.style.top;
    if (top) { pendingScrollY = parseInt(top) * -1; }
  }, true);

  document.addEventListener('click', function(e) {
    var cartDialog = document.querySelector('.cart-drawer__dialog');
    if (!cartDialog || !cartDialog.open) return;
    var rect = cartDialog.getBoundingClientRect();
    var inside = e.clientX >= rect.left && e.clientX <= rect.right &&
                 e.clientY >= rect.top  && e.clientY <= rect.bottom;
    if (!inside) {
      var top = document.body.style.top;
      if (top) pendingScrollY = parseInt(top) * -1;
    }
  }, true);

  window.scrollTo = function(xOrOptions, y) {
    if (
      pendingScrollY !== null &&
      xOrOptions !== null &&
      typeof xOrOptions === 'object' &&
      xOrOptions.behavior === 'instant'
    ) {
      var target = pendingScrollY;
      pendingScrollY = null;
      orig({ top: target, behavior: 'instant' });
      return;
    }
    pendingScrollY = null;
    if (typeof xOrOptions === 'object') {
      orig(xOrOptions);
    } else {
      orig(xOrOptions, y);
    }
  };
})();

/* ── Add price to ATC button ── */
(function() {
  if (window._mlAtcPricePatched) return;
  window._mlAtcPricePatched = true;

  function getPrice() {
    var el = document.querySelector(".price");
    return el ? el.textContent.trim().split("\n")[0].trim() : "";
  }

  function updateButton() {
    var btn = document.querySelector("button[type=submit].add-to-cart-button");
    if (!btn) return;
    var price = getPrice();
    if (!price) return;
    var existing = btn.querySelector(".ml-atc-price");
    if (existing) {
      existing.textContent = price;
    } else {
      var span = document.createElement("span");
      span.className = "ml-atc-price";
      span.textContent = price;
      span.style.cssText = "color:#fff!important;font-size:15px;font-weight:500;letter-spacing:-0.01em;opacity:0.9;margin-left:auto;";
      btn.appendChild(span);
    }
  }

  updateButton();
  document.addEventListener("DOMContentLoaded", updateButton);
  window.addEventListener("load", function() { setTimeout(updateButton, 300); setTimeout(updateButton, 1000); });

  document.addEventListener("change", function(e) {
    if (e.target && (e.target.name === "id" || e.target.closest("[data-variant-picker]"))) {
      setTimeout(updateButton, 200);
    }
  });

  setTimeout(function() {
    updateButton();
    var priceEl = document.querySelector(".price");
    if (priceEl) {
      new MutationObserver(function() { setTimeout(updateButton, 50); })
        .observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }, 800);
})();
